export const PushNotificationConstants = {
    NOTIFICATION_PLUGIN: 'Notification',
    ON_NOTIFICATION_RECEIVED: 'onNotificationReceived',
    ACTION_GET_NOTIFICATIONS: 'getNotifications',
    ACTION_DELETE_NOTIFICATIONS: 'deleteNotifications',
    ACTION_SET_CONTEXT_KEY: 'setContextKey',
    KEY_ZONE: 'zone',
    KEY_SUB_ZONE: 'subzone',
    KEY_LOGIN_STATUS: 'loginStatus',
    AUTH_STATUS_LOGGED_IN: 'LOGGED_IN',
    AUTH_STATUS_LOGGED_OUT: 'LOGGED_OUT',
}
